/** 指向共用界面的实际操作按钮，点击后由任务阶段移除。 */
export function DemoStartCue({ stage }: { stage: "explore" | "plan" }) {
  return (
    <div id={`demo-${stage}-hint`} className="demo-start-cue">
      <span>{stage === "explore" ? "按这个按钮开始探索任务" : "按这个按钮开始执行方案"}</span>
      <svg viewBox="0 0 64 58" aria-hidden="true" focusable="false">
        <path d="M6 6 C18 6 33 9 36 18 C42 36 16 38 16 22 C16 6 40 7 44 25 C48 36 49 43 49 54 M42 47 L49 54 L56 47" />
      </svg>
    </div>
  );
}
